export function IsPC() {
  var userAgentInfo = navigator.userAgent

  var Agents = [
    'Android',
    'iPhone',
    'SymbianOS',
    'Windows Phone',
    'iPad',
    'iPod',
  ]

  var flag = true
  for (var v = 0; v < Agents.length; v++) {
    if (userAgentInfo.indexOf(Agents[v]) > 0) {
      flag = false
      break
    }
  }

  return flag
}
/**
 * 校验是否符合11位手机号(必填)
 * @param {*} value 
 */
export function validatePhone(value) {
  const reg = /^1[0-9]{10}$/;
  return reg.test(value)
  
}

/**
 * 校验是否符合邮箱
 * @param {*} value 
 */
export function validateEMail(value) {
  const reg = /^\w+@[a-zA-Z0-9]{2,10}(?:\.[a-z]{2,4}){1,3}$/;
  if (value == '' || value == undefined || value == null) {
    return true
  } else {
    return reg.test(value)
  }
}

/**
 * 校验联系人名称是否符合20个字符内，只支持汉字和字母（必填）
 * @param {*} value 
 */
export function validate20Chart(value) {
  const reg = /^([A-Za-z]|[\u4E00-\u9FA5])+$/; /*定义验证汉字与字母表达式*/
  return value.length<21 && reg.test(value)
  
}